import React, { Component } from 'react'

export default class ThankYou extends Component {
  render() {
    return (
      <React.Fragment>
        <main>
          <div id="thankyou_page" className='pricing-area padding-top-100px padding-bottom-80px'>
              <div className="container">
                <div className="row justify-content-center text-center">
                  <div className="col-xl-8 col-lg-9">
                    <h2>THANK YOU! <i className="fa fa-check"></i></h2>
                    <p>Thank you for posting a Job at jobzshala.com. Your Job will be published after admin approval. 
                        <a href='/'> Click here</a> to login<br/>and update your profile and complete eKYC to become a trusted employer.</p>
                    {/* <form>
                      <div className="search_bar_error">
                        <input type="text" className="form-control" placeholder="What are you looking for?"/>
                        <input type="submit" value="Search"/>
                      </div>
                    </form> */}

                    <h6>After login you can:</h6>
                    <ul className='thankyoupoints'>
                        <li><i class="fa fa-check-circle"></i> Update Your Profile</li>
                        <li><i class="fa fa-check-circle"></i> Validate eKYC</li>
                        <li><i class="fa fa-check-circle"></i> Manage Jobs & Applications</li>
                        <li><i class="fa fa-check-circle"></i> Shortlist & Interviewed via Integrated Live Meeting <span><i class="fa fa-video-camera"></i></span></li>
                        <li><i class="fa fa-check-circle"></i> Select candidate & Issue Offer Letter</li>
                        <li><i class="fa fa-check-circle"></i> Onboard Candidate to JobzShala HRMS</li>
                        <li><i class="fa fa-check-circle"></i> Start Managing Attendance</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </main>
      </React.Fragment>
    )
  }
}
